<div class="loading-container">
    <div class="circle">
      <div class="light top" [ngClass]="lights[0]"></div>
      <div class="light right" [ngClass]="lights[1]"></div>
      <div class="light bottom" [ngClass]="lights[2]"></div>
      <div class="light left" [ngClass]="lights[3]"></div>
    </div>
  </div>
